import React from 'react';
import { TailSpin } from 'react-loading-icons';
import styled from 'styled-components';

const LoadingIconWrap = styled.div`
display: ${props=>props.state ? 'block' : 'none'};
position: relative;
top     : 0px;
left    : 0px;
height:${props=>props.wrapperHeight ?  props.wrapperHeight : ''};
&>div{
    position: absolute;
    top: 0px;
    left: 0px;
    // background-color: rgba(var(--lightGrayRGB), 0.5);
    width: 100%;
    height:${props=>props.height ?  props.height : ''};
    z-index:100;
    &>div{
        
        height:100%;
        display: flex;
        justify-content: center;
        align-items: center;
        
    }
    
}
`
export const LoadingIcon = ({state, height, wrapperHeight, iconHeight})=>{
    return <LoadingIconWrap state={state} height={height} wrapperHeight={wrapperHeight}>
        <div>
            <div>
                <TailSpin stroke={'var(--light-gray)'} strokeWidth="0.2rem" width={iconHeight||"3rem"} height={iconHeight||"3rem"} speed = {1.5} />
            </div>
        </div>
    </LoadingIconWrap>
}
export const CustomLoadingIcon = ({height, speed, strokeColor, customClassName, customStrokeWidth, marginLeft})=>{
    return <div className={customClassName || ''} style={{ display: 'inline-flex', alignItems: 'center', overflow: 'visible', padding: '2px 0' }}>
        <TailSpin 
            style={{ marginLeft: marginLeft, display: 'block', flexShrink: 0, overflow: 'visible' }}
            stroke={strokeColor || 'var(--light-gray)'} 
            strokeWidth={customStrokeWidth||"0.2rem"}
            width={height} 
            height={height} 
            speed = {speed} 	/>
    </div>
}